import {
  Image as JsImage,
  ImageType as JsImageType,
} from "@blacknut/javascript-sdk/dist";
export declare type ImageType = JsImageType;

/** @deprecated */
export declare type Image = JsImage;

export const getImageByThemeName = (
  themeName: string,
  images?: JsImage[],
): JsImage | undefined => {
  if (!images) return undefined;
  for (const image of images) {
    if (image.theme === themeName) return image;
  }
  return undefined;
};
